module.exports = __webpack_public_path__ + "static/object-browse-data.402c16e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/products/realfire/features/view-object-details/object-browse-data.png
// module id = 260
// module chunks = 62430881213916 95704636617618